import md5 from 'js-md5'

export const getSign = function (params) {
  let sorted = {},
  keys = Object.keys(params);
  keys.sort();
  keys.forEach((key)=>{
    sorted[key] = params[key];
  })

  let paramStr = ''
  for (let i in sorted) {
    paramStr += `${i}=${sorted[i]}`
  }
  paramStr += '691567CC77B4DDE097869F3B7FE68BB8'

  return md5(paramStr)
}

export const isMobile = function () {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export const isIOS = function () {
  return navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)
}

export const isWechat = function () {
  return navigator.userAgent.match(/micromessenger/i)
}